<template>
  <!-- Buttons to mark all as unmarked, present, or absent -->
  <div class="d-flex flex-column align-center ml-4">
    <div v-if="showLabel" class="mr-2">Mark All As</div>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="grey darken-2"
            v-bind="attrs"
            v-on="on"
            @click="$emit('on-mark', 'unmarked')"
          >
            mdi-checkbox-blank-outline
          </v-icon>
        </template>
        <span>Unmarked</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="green"
            v-bind="attrs"
            v-on="on"
            @click="$emit('on-mark', 'present')"
          >
            mdi-checkbox-marked
          </v-icon>
        </template>
        <span>Present</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red"
            v-bind="attrs"
            v-on="on"
            @click="$emit('on-mark', 'absent')"
          >
            mdi-close-box
          </v-icon>
        </template>
        <span>Absent</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        showLabel: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style>
</style>